import { MenuItem, TextField } from '@mui/material';
import { countries } from '../../../../../constants';

type CountryInputProps = {
  value: number;
  onChange: (value: number) => void;
};

export function CountryInput({ value, onChange }: CountryInputProps) {
  return (
    <TextField
      label='Nationalität'
      size='small'
      value={value}
      onChange={event => onChange(Number(event.target.value))}
      fullWidth
      select
      required
    >
      {countries.map(x => (
        <MenuItem key={`select-country-${x.idCountry}`} value={x.idCountry}>
          {x.Nationality}
        </MenuItem>
      ))}
    </TextField>
  );
}
